import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { WebSplashProvider } from './context/WebSplashContext';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <WebSplashProvider>
        <div className="app-viewport">
          <App />
        </div>
      </WebSplashProvider>
    </BrowserRouter>
  </StrictMode>,
);
